import { render } from "./IconCSV.vue?vue&type=template&id=92e9a16a"
import script from "./IconCSV.vue?vue&type=script&lang=ts"
export * from "./IconCSV.vue?vue&type=script&lang=ts"
script.render = render

export default script